module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c5",
    attrs: {
      "id": "calibre_pb_2",
      "lang": "de-DE",
      "xml:lang": "de-DE"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("I would like to thank my family, friends, and fans\nfor encouraging me to write and for believing in this series from\nthe start. Thank you Megan, Stephanie, Lori, and Lindsay for all of\nyour help, feedback, and excitement about this series and\nespecially this book. Thank you Jarred Johnson for helping me come\nup with this book’s title. And I would like to thank Jacob from\nPermuted Press for having faith in me as well as this series.")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_c('br', {
    staticClass: "calibre2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ef33e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue
// module id = 69
// module chunks = 0